import React, { useEffect,useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import "./TermsConditions.css";
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const TermsConditions = () => {
const [loading,setLoading] = useState(true);

const [inputs,setInputs] = useState({terms_conditions:''});

  useEffect(() => {
    document.title = `Terms&Conditions | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ter';
	
	window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth', 
    }); 
	
	/* Start get page data */
		let formData = new FormData(); 
		formData.append('type', 'terms_conditions');
		API.post('get_page',formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
			   setInputs({terms_conditions:response.data.data.terms_conditions});
			}                  
		}).catch(error => {
			 
		});  
	 /* End get page data */
	
  },[]);  

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/trust-service.png'}
          alt=""
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/trust-service.png'}
          alt=""
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container my-5">
        <div className="row">
            <div className="col-md-12 cousel">
                <h1>Terms and conditions</h1>
				<div dangerouslySetInnerHTML={{__html: inputs.terms_conditions}} />
            </div>
        </div>
      </div>
      <Appqr />
      <Footer />
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
    </>
  );
};

export default TermsConditions;